export const DatabaseName = '_ionicstorage'
